import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import QueryString from 'qs'
import { QueryKey, useInfiniteQuery } from 'react-query'
import { Photos } from 'unsplash-js/dist/methods/search/types/response'

interface Props {
  query: string
  queryKey?: QueryKey
  perPage?: number
}

interface Options {
  enabled?: boolean
}

export const useUnsplashImages = (
  { perPage = 12, query, queryKey = ['unsplashImages', query] }: Props,
  options: Options = {},
) => {
  const MINUTE = 1000 * 60
  const isRandom = !query
  const queryOptions = isRandom
    ? {
        cacheTime: MINUTE * 3,
        staleTime: MINUTE * 3,
      }
    : {
        cacheTime: MINUTE * 24,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
      }

  return useInfiniteQuery(
    queryKey,
    async ({ pageParam = 1 }) => {
      const url = isRandom
        ? `/unsplash/random?&page=${pageParam}&count=${perPage}`
        : `/unsplash/photos?query=${query}&page=${pageParam}&per_page=${perPage}`

      const response = await sendToApi<Photos>(url)
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error('Failed to load photos')
      }
      return response
    },
    {
      ...options,
      ...queryOptions,
      getNextPageParam: (lastPage) => {
        if (!lastPage) return undefined
        const totalPages = isRandom ? Infinity : Number(lastPage.data.total_pages)
        const nextPage = Number(QueryString.parse(lastPage.url.split('?')[1]).page) + 1

        if (nextPage <= totalPages) return nextPage

        return undefined
      },
    },
  )
}
